"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
var Fetch_1 = require("./Fetch");
Object.defineProperty(exports, "fetch", { enumerable: true, get: function () { return Fetch_1.Fetch; } });
